import React, { useEffect } from "react";
import LiveHeader from "./Header";
import LiveCampaign from "./Campaign";
import { connect } from "react-redux";
import NoCampaign from "./NoCampaign";
import { getListLiveCampaign } from "../../../../store/action/liveCampaignAction";
const _ = require('lodash');

function LiveCampaignList(props) {
  const { getListLiveCampaign, data, page } = props;

  useEffect(() => {
    if (!_.isEmpty(page)) {
      getListLiveCampaign();
    }
  }, [page]);

  const onChangePaginate = (page, pageSize) => {
    getListLiveCampaign(page, pageSize);
  }

  return (
    <div id="bot-scene-container" className="">
      <div id="bot-scene-content" className="scroll-light">
        <LiveHeader data={data} />
        {data.length > 0 ?
          <LiveCampaign />
          :
          <NoCampaign />
        }
      </div>
    </div>
  );
}

const mapStateToProps = (state) => {
  const { page, liveCampaign } = state;
  return {
    page,
    data: _.isArray(liveCampaign?.items) ? liveCampaign.items : []
  }
}

export default connect(mapStateToProps, {
  getListLiveCampaign
})(LiveCampaignList);
